<template>
  <div class="param_common">
    <p>
      フィラーを含めた商品の寸法を入力してください。<br>
      壁壁や床天で納める場合は、商品の扉がドア枠や照明に当たらないか、搬入可能かどうかを注意して寸法確認ください。
    </p>
    <!-- 商品サイズ -->
    <div id="prodcut_input_area">
      <!-- <div class="product_input_title">
        <h2 v-if="isDisableCosntructHeight">商品寸法と取り付け高さをご入力ください。</h2>
        <h2 v-else>商品寸法をご入力ください。</h2>
      </div> -->
      <div id="reference_image" v-if="isExistReferenceImage">
        <ul class="ul_tab" v-if="targetPlan.inputReferenceList.length > 1">
          <li v-for="(inputRef, index) in targetPlan.inputReferenceList" :key="'inputRef-' + index"
            @click="tabType=inputRef.tabId" v-bind:class="{active: tabType==inputRef.tabId, tab_title: true}">{{inputRef.tabName}}</li>
        </ul>
        <div v-for="(inputRef, index) in targetPlan.inputReferenceList" :key="'inputRefImage-' + index">
          <div v-if="tabType==inputRef.tabId">
            <img :src="getImage('top/item/input/' + inputRef.img)" width="100%" height="100%">
          </div>
        </div>
      </div>
      <div :class="{product_input_size_area: isExistReferenceImage, product_input_size_area2: !isExistReferenceImage}">
        <div class="product_input_size">
          <div>
            <div>幅</div>
            <div class="fixed_size" v-if="isDisableWidth">{{paramForm.width}}</div>
            <div v-else>
              <input type="text" v-model="paramForm.width" @keypress="validateNumber" @input="paramForm.width=inputRestNumber($event)" @blur="onBlurStorageItemW" @focus="selectedAll">
            </div>
          </div>
          <div class="small_text">設定可能値:{{paramForm.minWidth}}mm ～ {{paramForm.maxWidth}}mm</div>
        </div>
        <div class="product_input_size">
          <div>
            <div>高さ</div>
            <div class="fixed_size" v-if="isDisableHeight">{{paramForm.height}}</div>
            <div v-else>
              <input type="text" v-model="paramForm.height" @keypress="validateNumber" @input="paramForm.height=inputRestNumber($event)" @blur="onBlurStorageItemH" @focus="selectedAll">
            </div>
          </div>
          <div class="small_text">設定可能値:{{paramForm.minHeight}}mm ～ {{paramForm.maxHeight}}mm</div>
        </div>
        <div class="product_input_size">
          <div>
            <div>奥行き</div>
            <div class="fixed_size" v-if="isDisableDepth">{{paramForm.depth}}</div>
            <div v-else>
              <input type="text" v-model="paramForm.depth" @keypress="validateNumber" @input="paramForm.depth=inputRestNumber($event)" @blur="onBlurStorageItemD" @focus="selectedAll">
            </div>
          </div>
          <div>設定可能値:{{paramForm.minDepth}}mm ～ {{paramForm.maxDepth}}mm</div>
        </div>
        <!-- <div class="detail_btn3">サイズ決定の注意事項はこちら</div> -->
      </div>
    </div>
    <div class="errors_field">
      <div v-if="errors.width" class="error_text middle_text">{{errors.width}}</div>
      <div v-if="errors.height" class="error_text middle_text">{{errors.height}}</div>
      <div v-if="errors.depth" class="error_text middle_text">{{errors.depth}}</div>
    </div>
    <!-- 取り付け高さ -->
    <div class="open_area" v-if="isDisableCosntructHeight">
      <div class="ds_content">
        <div class="ds_left">
          <ul>
            <li>床から天井までの高さを入力してください。</li>
            <li v-if="isActiveCG">CGや図面に取り付け位置の高さを反映します。</li>
            <li v-else>図面に取り付け位置の高さを反映します。</li>
          </ul>
          <div class="product_input_size">
            <div class="size_title bold">床H</div>
            <div class="size_comb">
              <input type="text" v-model="paramForm.height2" @blur="onBlurStorageItemH2" maxlength="6" @keypress="validateNumber" @input="paramForm.height2=inputRestNumber($event)" @focus="selectedAll"/>
              <div class="small_text"><label>{{paramForm.minHeight2}}～{{paramForm.maxHeight2}}mm</label></div>
            </div>
          </div>
        </div>
      </div>
      <div class="errors_field">
        <label v-if="errors.height2" class="error_text middle_text">{{errors.height2}}</label>
      </div>
    </div>
    <!-- フィラー -->
    <div class="product_input_filler">
      <div class="product_input_title">
        <h3>フィラーをご選択ください。</h3>
      </div>
      <p v-if="isExistEndPanel">エンドパネルは<span class="pickup">21mm</span>です。</p>
      <p>
        フィラーは入力されたW寸法により以下の３種類から自動選択されます。<br>
        ①{{fillerSize}}mm×70mm ②{{fillerSize}}mm×100mm ③{{fillerSize}}mm×200mm 長尺は900mmまたは1800mm
      </p>
    </div>
    <div class="filler_input_size_area">
      <div class="filler_input_size" v-if="!paramForm.fillerDisableLeft">
        <div>左</div>
        <div>
          <div class="filler_input">
            <div class="radio">
              <input type="radio" id="l_filler1" name="left_filler" value=1 v-model.number="paramForm.fillerTypeLeft" @click="changeLeftFiller"/>
              <label for="l_filler1" class="radio-label">フィラー</label>
            </div>
            <div class="size_comb">
              <input type="text" :disabled="isLeftFiller===false"
                v-model="paramForm.fillerSizeLeft"
                @keypress="validateNumber"
                @input="paramForm.fillerSizeLeft=inputRestNumber($event)"
                v-bind:class="{warns_color: warns.fillerLeft}"
                @blur="onBlurFillerLeft"
                @focus="selectedAll">
            </div>
          </div>
        </div>
        <div v-if="isExistEndPanel">
          <div class="filler_input">
            <div class="radio">
              <input type="radio" id="l_filler2" name="left_filler" value=2 v-model.number="paramForm.fillerTypeLeft" @click="changeLeftFiller" />
              <label for="l_filler2" class="radio-label">エンドパネル21mm</label>
            </div>
          </div>
          <div></div>
        </div>
        <div>
          <div class="filler_input">
            <div class="radio">
              <input type="radio" id="l_filler3" name="left_filler" value=0 v-model.number="paramForm.fillerTypeLeft" @click="changeLeftFiller" />
              <label for="l_filler3" class="radio-label">なし</label>
            </div>
          </div>
          <div></div>
        </div>
      </div>
      <div class="setting_value" v-if="!paramForm.fillerDisableLeft">設定可能値:{{fillerSize}}mm ～ 200mm</div>
      <div class="filler_input_size" v-if="!paramForm.fillerDisableRight">
        <div>右</div>
        <div>
          <div class="filler_input">
            <div class="radio">
              <input type="radio" id="r_filler1" name="right_filler" value=1 v-model.number="paramForm.fillerTypeRight" @click="changeRightFiller" />
              <label for="r_filler1" class="radio-label">フィラー</label>
            </div>
            <div class="size_comb">
              <input type="text" :disabled="isRightFiller===false"
                v-model="paramForm.fillerSizeRight"
                @keypress="validateNumber"
                @input="paramForm.fillerSizeRight=inputRestNumber($event)"
                v-bind:class="{warns_color: warns.fillerRight}"
                @blur="onBlurFillerRight"
                @focus="selectedAll">
            </div>
          </div>
        </div>
        <div v-if="isExistEndPanel">
          <div class="filler_input">
            <div class="radio">
              <input type="radio" id="r_filler2" name="right_filler" value=2 v-model.number="paramForm.fillerTypeRight" @click="changeRightFiller"/>
              <label for="r_filler2" class="radio-label">エンドパネル21mm</label>
            </div>
          </div>
          <div></div>
        </div>
        <div>
          <div class="filler_input">
            <div class="radio">
              <input type="radio" id="r_filler3" name="right_filler" value=0 v-model.number="paramForm.fillerTypeRight" @click="changeRightFiller"/>
              <label for="r_filler3" class="radio-label">なし</label>
            </div>
          </div>
          <div></div>
        </div>
      </div>
      <div class="setting_value" v-if="!paramForm.fillerDisableRight">設定可能値:{{fillerSize}}mm ～ 200mm</div>
      <div class="filler_input_size" v-if="!paramForm.fillerDisableCounter">
        <div>上</div>
        <div>
          <div class="filler_input">
            <div class="radio">
              <input type="radio" id="u_filler1" name="top_filler" value=1 v-model.number="paramForm.fillerTypeCounter" @click="changeCounterFiller"/>
              <label for="u_filler1" class="radio-label">フィラー</label>
            </div>
            <div class="size_comb">
              <input type="text" :disabled="isCenterFiller===false"
                v-model="paramForm.fillerSizeCounter"
                @keypress="validateNumber"
                @input="paramForm.fillerSizeCounter=inputRestNumber($event)"
                v-bind:class="{warns_color: warns.fillerCounter}"
                @blur="onBlurFillerCenter"
                @focus="selectedAll">
            </div>
          </div>
        </div>
        <div>
          <div class="filler_input">
            <div class="radio">
              <input type="radio" id="u_filler2" name="top_filler" value=0 v-model.number="paramForm.fillerTypeCounter" @click="changeCounterFiller"/>
              <label for="u_filler2" class="radio-label">なし</label>
            </div>
          </div>
        </div>
        <div> </div>
      </div>
      <div class="setting_value" v-if="!paramForm.fillerDisableCounter">設定可能値:{{fillerSize}}mm ～ 200mm</div>
      <div class="warns_field">
        <div v-if="warns.fillerLeft" class="error_text middle_text">{{warns.fillerLeft}}</div>
        <div v-if="warns.fillerRight" class="error_text middle_text">{{warns.fillerRight}}</div>
        <div v-if="warns.fillerCounter" class="error_text middle_text">{{warns.fillerCounter}}</div>
      </div>
    </div>
  </div>
</template>
<script>
import * as Check from '../../../../../utils/Check'
import * as App from '../../../../../utils/App'
import * as FormUtil from '../../../../../utils/FormUtil'
import ToolTip from '../../../../../components/common/ToolTip'

const ENDPANEL_SIZE = 15
const MAX_FILLER_SIZE = 200

export default {
  components: {
    'tool-tip': ToolTip
  },
  props: {
    targetPlan: Object,
    isDisableForm: Boolean,
    isExecOrder: Boolean,
    isStruct: Boolean,
    isExistEndPanel: Boolean,
    isMiura: Boolean,
    isActiveCG: Boolean
  },
  data () {
    return {
      paramForm: {
        width: '',
        height: '',
        height2: '',
        depth: '',
        depth2: '',
        minWidth: '',
        maxWidth: '',
        minHeight: '',
        maxHeight: '',
        minHeight2: '',
        maxHeight2: '',
        minDepth: '',
        maxDepth: '',
        minDepth2: '',
        maxDepth2: '',
        fillerSizeLeft: '',
        fillerSizeRight: '',
        fillerSizeCounter: '',
        fillerTypeLeft: 0,
        fillerTypeRight: 0,
        fillerTypeCounter: 0,
        fillerDisableLeft: false,
        fillerDisableRight: false,
        fillerDisableCounter: false
      },
      errors: {},
      warns: {},
      imgQmark: this.getImage('common/qmark_gray.svg'),
      isOpenDrawSetting: false,
      tabType: 1
    }
  },
  watch: {
    targetPlan: function (plan) {
      console.log('param size filter watch')
      this.paramForm.width = plan.dcWidth
      this.paramForm.height = plan.dcHeight
      this.paramForm.height2 = plan.dcHeight2
      this.paramForm.depth = plan.dcDepth
      this.paramForm.depth2 = plan.dcDepth2
      this.paramForm.minWidth = plan.dcMinWidth
      this.paramForm.maxWidth = plan.dcMaxWidth
      this.paramForm.minHeight = plan.dcMinHeight
      this.paramForm.maxHeight = plan.dcMaxHeight
      this.paramForm.minHeight2 = plan.dcMinHeight2
      this.paramForm.maxHeight2 = plan.dcMaxHeight2
      this.paramForm.minDepth = plan.dcMinDepth
      this.paramForm.maxDepth = plan.dcMaxDepth
      this.paramForm.minDepth2 = plan.dcMinDepth2
      this.paramForm.maxDepth2 = plan.dcMaxDepth2
      this.paramForm.fillerSizeLeft = plan.dcBSize
      this.paramForm.fillerSizeRight = plan.dcCSize
      this.paramForm.fillerSizeCounter = plan.dcDSize
      this.paramForm.fillerTypeLeft = plan.dcBType
      this.paramForm.fillerTypeRight = plan.dcCType
      this.paramForm.fillerTypeCounter = plan.dcDType
      this.paramForm.fillerDisableLeft = plan.dcBTypeDisableFlg
      this.paramForm.fillerDisableRight = plan.dcCTypeDisableFlg
      this.paramForm.fillerDisableCounter = plan.dcDTypeDisableFlg
    }
  },
  computed: {
    itemWidth: function () {
      let size = Number(this.paramForm.width)
      if (this.paramForm.fillerTypeLeft === 1) {
        size -= Number(this.paramForm.fillerSizeLeft)
      }
      if (this.paramForm.fillerTypeRight === 1) {
        size -= Number(this.paramForm.fillerSizeRight)
      }

      // マイナス値にはさせない
      if (size <= 0) {
        size = Number(0)
      }
      return size
    },
    itemHeight: function () {
      // 収納スペース - フィラーを商品サイズに適用する
      let size = Number(this.paramForm.height)
      if (this.paramForm.fillerTypeCounter === 1) {
        size -= Number(this.paramForm.fillerSizeCounter)
      }

      // マイナス値にはさせない
      if (size <= 0) {
        size = Number(0)
      }
      return size
    },
    itemDepth: function () {
      // 収納スペース - フィラーを商品サイズに適用する
      let size = Number(this.paramForm.depth)

      // マイナス値にはさせない
      if (size <= 0) {
        size = Number(0)
      }
      return size
    },
    isDisableWidth: function () {
      return this.paramForm.minWidth === this.paramForm.maxWidth
    },
    isDisableHeight: function () {
      return this.paramForm.minHeight === this.paramForm.maxHeight
    },
    isDisableDepth: function () {
      return this.paramForm.minDepth === this.paramForm.maxDepth
    },
    isLeftFiller: function () {
      if (!this.paramForm.fillerTypeLeft) return false
      if (Number(this.paramForm.fillerTypeLeft) === 1) {
        return true
      }
      return false
    },
    isRightFiller: function () {
      if (!this.paramForm.fillerTypeRight) return false
      if (Number(this.paramForm.fillerTypeRight) === 1) {
        return true
      }
      return false
    },
    isCenterFiller: function () {
      if (!this.paramForm.fillerTypeCounter) return false
      if (Number(this.paramForm.fillerTypeCounter) === 1) {
        return true
      }
      return false
    },
    isEnableHeight2: function () {
      if (this.paramForm.minHeight2 === undefined && this.paramForm.maxHeight2 === undefined) return false
      if (this.paramForm.minHeight2 === 0 && this.paramForm.maxHeight2 === 0) return false
      return true
    },
    isDisableCosntructHeight: function () {
      return (this.isEnableHeight2 && this.isStruct)
    },
    fillerSize: function () {
      if (this.isMiura) {
        return 20
      }
      return 15
    },
    isExistReferenceImage: function () {
      if (this.targetPlan.inputReferenceList && this.targetPlan.inputReferenceList.length > 0) return true
      return false
    }
  }, // end computed
  methods: {
    getParam: function () {
      let param = {
        width: this.paramForm.width,
        height: this.paramForm.height,
        height2: this.isEnableHeight2 ? this.paramForm.height2 : undefined,
        depth: this.paramForm.depth,
        depth2: this.paramForm.depth2,
        minWidth: this.paramForm.minWidth,
        maxWidth: this.paramForm.maxWidth,
        minHeight: this.paramForm.minHeight,
        maxHeight: this.paramForm.maxHeight,
        minDepth: this.paramForm.minDepth,
        maxDepth: this.paramForm.maxDepth,
        fillerSizeLeft: this.getFillerSizeLeft(),
        fillerSizeRight: this.getFillerSizeRight(),
        fillerSizeCounter: this.getFillerSizeCounter(),
        fillerTypeLeft: this.paramForm.fillerTypeLeft,
        fillerTypeRight: this.paramForm.fillerTypeRight,
        fillerTypeCounter: this.paramForm.fillerTypeCounter,
        fillerDisableLeft: this.paramForm.fillerDisableLeft,
        fillerDisableRight: this.paramForm.fillerDisableRight,
        fillerDisableCounter: this.paramForm.fillerDisableCounter
      }
      return param
    },
    validateNumber: function (event) {
      if (!Check.isNumber(event.key)) {
        event.preventDefault()
        return false
      }
      return true
    },
    changeLeftFiller: function (event) {
      // フィラーのチェックを設定する
      if (Number(event.target.value) !== 0) {
        this.paramForm.fillerTypeLeft = Number(event.target.value)
        if (this.isMiura) {
          this.paramForm.fillerSizeLeft = 20
        } else {
          this.paramForm.fillerSizeLeft = 15
        }
      } else {
        this.paramForm.fillerTypeLeft = 0
        this.paramForm.fillerSizeLeft = 0
        delete this.warns.fillerLeft
      }

      // 設定した値をチェックする
      this.validateItemW()
    },
    changeRightFiller: function (event) {
      if (Number(event.target.value) !== 0) {
        this.paramForm.fillerTypeRight = Number(event.target.value)
        if (this.isMiura) {
          this.paramForm.fillerSizeRight = 20
        } else {
          this.paramForm.fillerSizeRight = 15
        }
      } else {
        this.paramForm.fillerTypeRight = 0
        this.paramForm.fillerSizeRight = 0
        delete this.warns.fillerRight
      }

      // 設定した値をチェックする
      this.validateItemW()
    },
    changeCounterFiller: function (event) {
      if (Number(event.target.value) !== 0) {
        this.paramForm.fillerTypeCounter = Number(event.target.value)
        if (this.isMiura) {
          this.paramForm.fillerSizeCounter = 20
        } else {
          this.paramForm.fillerSizeCounter = 15
        }
      } else {
        this.paramForm.fillerTypeCounter = 0
        this.paramForm.fillerSizeCounter = 0
        delete this.warns.fillerCounter
      }

      // 設定した値をチェックする
      this.validateItemH()
    },
    onBlurFillerLeft: function () {
      this.paramForm.fillerSizeLeft = this.checkFillerLeft(Number(this.paramForm.fillerSizeLeft))

      // 計算前の値をチェックする。
      let ret = this.validateItemW()
      if (!ret) {
        return false
      }
    },
    onBlurFillerRight: function () {
      this.paramForm.fillerSizeRight = this.checkFillerRight(Number(this.paramForm.fillerSizeRight))

      // 計算後の値をチェックする
      let ret = this.validateItemW()
      if (!ret) {
        return false
      }
    },
    onBlurFillerCenter: function () {
      this.paramForm.fillerSizeCounter = this.checkMaxFillerCounter(Number(this.paramForm.fillerSizeCounter))

      // 計算後の値をチェックする
      let ret = this.validateItemH()
      if (!ret) {
        return false
      }
    },
    onBlurStorageItemW: function () {
      if (!this.paramForm.width || this.paramForm.width <= 0) {
        this.paramForm.width = 0
      }
      // 計算後の値をチェックする。
      let ret = this.validateItemW()
      if (!ret) {
        return false
      }
    },
    onBlurStorageItemH: function () {
      if (!this.paramForm.height || this.paramForm.height <= 0) {
        this.paramForm.height = 0
      }
      // 計算前の値をチェックする
      let ret = this.validateItemH()
      if (!ret) {
        return false
      }
    },
    onBlurStorageItemH2: function () {
      // 計算前の値をチェックする
      let ret = this.validateItemH2()
      if (!ret) {
        return false
      }
    },
    onBlurStorageItemD: function () {
      // 商品サイズ
      if (!this.paramForm.depth || this.paramForm.depth <= 0) {
        this.paramForm.depth = 0
      }
      let ret = this.validateItemD()
      if (!ret) {
        return false
      }
    },
    selectedAll: function (event) {
      event.target.select()
    },
    inputRestNumber: function (event) {
      // テキスト補正
      let str = FormUtil.restHalfNumber(event.target.value)
      str = FormUtil.deleteTopZero(str)
      return str
    },
    checkFillerLeft: function (size) {
      let retSize = 0
      if (size < this.fillerSize) {
        this.warns['fillerLeft'] = '警告：左フィラーの最小値は' + this.fillerSize + 'mmです。'
        retSize = this.fillerSize
      } else if (size > MAX_FILLER_SIZE) {
        this.warns['fillerLeft'] = '警告：左フィラーの最大値は' + MAX_FILLER_SIZE + 'mmです。'
        retSize = MAX_FILLER_SIZE
      } else {
        delete this.warns.fillerLeft
        retSize = size
      }
      this.$forceUpdate()
      return retSize
    },
    checkFillerRight: function (size) {
      let retSize = 0
      if (size < this.fillerSize) {
        this.warns['fillerRight'] = '警告：右フィラーの最小値は' + this.fillerSize + 'mmです。'
        retSize = this.fillerSize
      } else if (size > MAX_FILLER_SIZE) {
        this.warns['fillerRight'] = '警告：右フィラーの最大値は' + MAX_FILLER_SIZE + 'mmです。'
        retSize = MAX_FILLER_SIZE
      } else {
        delete this.warns.fillerRight
        retSize = size
      }
      this.$forceUpdate()
      return retSize
    },
    checkMaxFillerCounter: function (size) {
      let retSize = 15
      if (size < this.fillerSize) {
        this.warns['fillerCounter'] = '警告：上部フィラーの最小値は' + this.fillerSize + 'mmです。'
        retSize = this.fillerSize
      } else if (size > MAX_FILLER_SIZE) {
        this.warns['fillerCounter'] = '警告：上部フィラーの最大値は' + MAX_FILLER_SIZE + 'mmです。'
        retSize = MAX_FILLER_SIZE
      } else {
        delete this.warns.fillerCounter
        retSize = size
      }
      this.$forceUpdate()
      return retSize
    },
    getFillerSizeLeft: function () {
      if (!this.paramForm.fillerTypeLeft) return 0
      if (Number(this.paramForm.fillerTypeLeft) === 1) {
        return this.paramForm.fillerSizeLeft
      } else if (Number(this.paramForm.fillerTypeLeft) === 2) {
        return ENDPANEL_SIZE
      }
      return 0
    },
    getFillerSizeRight: function () {
      if (!this.paramForm.fillerTypeRight) return 0
      if (Number(this.paramForm.fillerTypeRight) === 1) {
        return this.paramForm.fillerSizeRight
      } else if (Number(this.paramForm.fillerTypeRight) === 2) {
        return ENDPANEL_SIZE
      }
      return 0
    },
    getFillerSizeCounter: function () {
      if (!this.paramForm.fillerTypeCounter) return 0
      if (Number(this.paramForm.fillerTypeCounter) === 1) {
        return this.paramForm.fillerSizeCounter
      } else if (Number(this.paramForm.fillerTypeCounter) === 2) {
        return ENDPANEL_SIZE
      }
      return 0
    },
    checkParam: function () {
      let isCheckW = this.validateItemW()
      let isCheckH = this.validateItemH()
      let isCheckD = this.validateItemD()
      let isCHeckH2 = this.validateItemH2()
      return isCheckW && isCheckH && isCheckD && isCHeckH2
    },
    validateItemW: function () {
      let ret = true
      // 商品サイズのチェック
      if (this.itemWidth < this.paramForm.minWidth) {
        this.errors['width'] = 'Wの商品サイズ（商品入力値 - フィラー入力値）は最小商品寸法より大きい値になるようにご入力ください。'
        ret = false
      } else if (this.itemWidth > this.paramForm.maxWidth) {
        this.errors['width'] = 'Wの商品サイズ（商品入力値 - フィラー入力値）は最大商品寸法より小さい値になるようにご入力ください。'
        ret = false
      }

      if (ret) {
        delete this.errors.width
      }
      this.$forceUpdate()
      return ret
    },
    validateItemH: function () {
      let ret = true
      if (this.itemHeight < this.paramForm.minHeight) {
        this.errors['height'] = 'Hの商品サイズ（商品入力値 - フィラー入力値）は最小商品寸法より大きい値になるようにご入力ください。'
        ret = false
      } else if (this.itemHeight > this.paramForm.maxHeight) {
        this.errors['height'] = 'Hの商品サイズ（商品入力値 - フィラー入力値）は最大商品寸法より小さい値になるようにご入力ください。'
        ret = false
      }
      if (ret) {
        delete this.errors.height
      }
      this.$forceUpdate()
      return ret
    },
    validateItemH2: function () {
      if (!this.isEnableHeight2) return true
      let ret = true
      if (this.paramForm.height2 < this.paramForm.minHeight2) {
        this.errors['height2'] = '取り付けの高さは' + this.paramForm.minHeight2 + 'mm以上になるようにご入力ください。'
        ret = false
      } else if (this.paramForm.height2 > this.paramForm.maxHeight2) {
        this.errors['height2'] = '取り付けの高さは' + this.paramForm.maxHeight2 + 'mm以下になるようにご入力ください。'
        ret = false
      }
      if (ret) {
        delete this.errors.height2
      }
      this.$forceUpdate()
      return ret
    },
    validateItemD: function () {
      let ret = true
      if (this.itemDepth < this.paramForm.minDepth) {
        this.errors['depth'] = 'Dの商品サイズは最小商品寸法より大きい値になるようにご入力ください。'
        ret = false
      } else if (this.itemDepth > this.paramForm.maxDepth) {
        this.errors['depth'] = 'Dの商品サイズは最大商品寸法より小さい値になるようにご入力ください。'
        ret = false
      }

      if (ret) {
        delete this.errors.depth
      }
      this.$forceUpdate()
      return ret
    },
    selectDrawSetting: function () {
      this.isOpenDrawSetting = !this.isOpenDrawSetting
    },
    getImage: function (image) {
      return App.getMmstyleResource(image)
    }
  },
  mounted: function () {
  }
}
</script>
<style src="../../../../css/dc-customize.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/main/js/payment/components/top/input/paramater/DcParamSizeFiller.vue